import { FormDeparturePicker } from './FormDeparturePicker';

export default FormDeparturePicker;
